import styled from 'styled-components'
import { BannerModule } from '~/components/business/BannerModule'
import { Container } from '~/components/ui/Container'
import { getBannerList_marketingModule_bannerList } from '~/graphqls/types'

const StyledFeatureSection = styled.section``

export const FeatureSection: React.FC<{
  data: getBannerList_marketingModule_bannerList[]
}> = ({ data }) => {
  return (
    <StyledFeatureSection>
      <Container>
        <BannerModule data={data} height={373} />
      </Container>
    </StyledFeatureSection>
  )
}
